import { md5, CryptoJS } from '@src/common/dependencies';
import { HelperCore } from '@/common/helper';
import slsLogger from '@public/log/sls';
import globalStore from '@/store/global';
import { loadModule } from '@/common/loadModule';

window.aiso_base64 = (str) => {
  return btoa(str);
}
window.aiso_md5 = (str) => {
  return md5(str);
}
window.aiso_aes = (str, secret) => {
  return CryptoJS.AES.encrypt(str, secret).toString();
}
window.aiso_sha1 = (str) => {
  return CryptoJS.SHA1(str).toString();
}
window.aiso_h256 = (str, secret) => {
  return CryptoJS.HmacSHA256(str, secret).toString();
}

const slsReport = (params) => {
  if(HelperCore.IS_ONLINE){
    slsLogger.log(params);
  }
}

/**
 * 调用 chat 接口时，执行注入 index.html 的签名函数，生成 header
 *  Chat-Date
 *  Chat-Token
 * @param {String} uri
 * @param {Object} body 
 */
export const getChatToken = async (uri, body) => {
  const date = (globalStore.currentTimestamp ? new Date(globalStore.currentTimestamp * 1000) : new Date()).toGMTString();

  let data = {
    "Chat-Date" : date,
    "Chat-Token" : "",
  }
  // const $jsText = document.querySelector("#chat-creater");
  // if(!$jsText){
  //   slsReport({
  //     action : "sign_error",
  //     ext : "empty",
  //     ext1 : "dom"
  //   });
  //   data["Chat-Token"] = "-1";
  //   return data;
  // }
  // let jsText = $jsText.innerHTML.trim();
  await loadModule('chatsdk').catch(err => false);
  let jsText = window.AISO_CHAT_TOKEN;
  if(!jsText){
    slsReport({
      action : "sign_error",
      ext : "empty",
      ext1 : "html"
    });
    data["Chat-Token"] = "-1";
    return data;
  }
  const jsFunction = jsText;
  try{
    jsText = window.atob(jsText).trim();
    // 容错，等服务端修改后去掉
    // if(!jsText.startsWith("(")){
    //   jsText = `(${jsText})`;
    // }
    // method, uri, access_token, http_version, date
    jsText += `(${JSON.stringify({
      method : "POST",
      uri,
      access_token : HelperCore.getMid(),
      http_version : "HTTP/1.1",
      date,
      body,
    })})`;

    // debug
    // HelperCore.log(`解析 token js 脚本:`, jsText);

    const { token } = eval(jsText);
    data["Chat-Token"] = token;
  } catch(e){
    if(!HelperCore.IS_ONLINE){
      HelperCore.log(`解析 token js 脚本报错:`, jsText, e);
    }
    slsLogger.log({
      action : "sign_error",
      ext : "function",
      ext1 : e.stack || e.toString(),
      ext2 : jsFunction,
    });
    data["Chat-Token"] = "-2";
  }

  return data;
}

// debug
// if(HelperCore.IS_LOCAL){
//   $(document.body).after(`
//   <script type="text/template" id="chat-creater">
//     ${window.btoa(`
//       (function ({ method, uri, access_token, http_version, date }) {
//         let token = method + " " + uri + " " + http_version +
//             "date: " + date;
//         token = aiso_base64(token);
//         token = aiso_md5(token);
//         token = aiso_aes(token, access_token);
//         token = aiso_aes(token, access_token);
//         token = aiso_aes(token, access_token);
//         token = aiso_aes(token, access_token);
//         token = aiso_md5(token);
//         token = aiso_md5(token);
//         token = aiso_base64(token);
//         token = aiso_aes(token, access_token);
//         return {
//             token: token + "AcDjy7LsI8gasdKz7gtG"
//         }
//       })
//     `)}
//   </script>
//   `)
// }

// debug
// if(HelperCore.IS_LOCAL){
//   window.CryptoJS = CryptoJS;
// }